import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Transactions from "../components/plans/Transactions";

const TransactionsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Transactions' />

                <Transactions />

            </MasterLayout>
        </>
    );
};

export default TransactionsPage;
